export default __webpack_public_path__ + "static/wire1-2bf2d92c4b8a2daf0914fa5897f06dc6.png";